import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';

import { Store } from '@ngrx/store';
import { LabelActions } from 'projects/semeris/src/store/label/label.actions';
import { LabelSelectors } from 'projects/semeris/src/store/label/label.selectors';

import { LabelCategories } from '../../../label/constants/label-categories';
import { Label } from '../../../label/models/label.model';
import { IconButtonDirective } from '../../../ui/button/icon-button/icon-button.directive';
import { FastTooltipDirective } from '../../directives/fast-tooltip.directive';
import { HintOverlayComponent } from '../hint-overlay/hint-overlay.component';
import { LabelInputComponent } from '../label-input/label-input.component';

@Component({
  selector: 'semeris-default-label-selector',
  imports: [
    CommonModule,
    MatIconModule,
    MatBadgeModule,
    LabelInputComponent,
    HintOverlayComponent,
    IconButtonDirective,
    FastTooltipDirective,
    CdkOverlayOrigin,
  ],
  templateUrl: './default-label-selector.component.html',
  styleUrls: ['./default-label-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultLabelSelectorComponent implements OnInit {
  private readonly store = inject(Store);

  public labels$ = this.store.select(LabelSelectors.getLabelsByCategory(LabelCategories.Notes));
  public defaultLabels$ = this.store.select(LabelSelectors.defaultLabelIds);

  public ngOnInit(): void {}

  public onValueChanged(labelIds: string[]) {
    this.store.dispatch(LabelActions.SetDefaultLabels({ labels: labelIds }));
  }

  public onLabelCreated(label: Label) {
    console.log(label);
  }
}
